import Vue from 'vue';
import Vuex from 'vuex';
import {setupStore} from '@customer-portal/shared';

export default setupStore(Vue, Vuex);
